// extracted by mini-css-extract-plugin
export default {"PromotionsContainer":"Home_PromotionsContainer__3AHjR","Promotion":"Home_Promotion__IieYh"};